import { Injectable } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { FabricModal } from './fabric.modal';

@Injectable({
  providedIn: 'root',
})
export class FabricModalService {
  constructor(private modalCtrl: ModalController) {}

  public async show(input, node, auditNodes, documentEditService, fullPageModal = false) {
    const modal = await this.modalCtrl.create({
      component: FabricModal,
      componentProps: {
        imageInput: input,
        node: node,
        auditNodes: auditNodes,
        documentEditService: documentEditService,
      },
      cssClass: fullPageModal ? 'fullPageModal' : ''
    });
    await modal.present();
    await modal.onDidDismiss();
  }
}
